import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import JapaneseTextAnalyzer from '@/components/JapaneseTextAnalyzer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<JapaneseTextAnalyzer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;